<template>
    <div class="panel-content">
        <h2>Waarin wij ons onderscheiden</h2>
        <img class="header" src="/static/img/overlay-assets/header3-2.jpg" />
        <p>Bij FutureChemistry ontwerpen we de apparaten waarmee onze toekomstige medische isotopen op een veilige manier kunnen worden gezuiverd en verwerkt tot radioactief gelabelde medicijnen voor behandelingen en diagnoses. FutureChemistry is in staat om deze apparaten te ontwikkelen, door de aanwezigheid van specifieke kennis over de chemie van die medische isotopen, en de specifieke kennis voor het ontwerpen van apparaten.</p>
    </div>
</template>

<style lang="scss" scoped>

</style>

<script>
    export default {

    };
</script>
